import ab, { ABTestID } from 'src/replicant/ruleset/ab';
import { duration } from 'src/replicant/utils/duration';
import StateObserver from 'src/StateObserver';
import { AB } from './AB';
import { withLoading } from './utils';

// Executed only once after user is logged in per session. Does not need to be
// repeated when user state is refreshed. Cannot be part of the replicant
// onLogin action (if we ever do it), since it depends on platform.
export function sessionSetup() {
  // Set up A/B tests
  void StateObserver.invoke.setAbTests(
    (Object.keys(ab.config) as ABTestID[]).reduce((result, testId) => {
      const bucket = AB.getBucketID(testId);
      if (!bucket) {
        return result;
      }

      return { ...result, [testId]: bucket };
    }, {}),
  );

  void StateObserver.invoke.heartbeat();
  setInterval(() => {
    if (StateObserver.replicant && !StateObserver.replicant.isPaused()) {
      void StateObserver.invoke.heartbeat();
    }
  }, duration({ seconds: 30 }));

  // Kick any players currently visiting us - not needed in web version
  // StateObserver.replicant.asyncGetters.getCurrentVisitors().then((visitors) => {
  //   StateObserver.invoke.kickVisitors(visitors);
  // });

  // Set up a default user name for the user, because there is no guarantee that the player
  // will have a name already set, avoiding situations like the pet saying "Hello, undefined!"
  if (!StateObserver.getState().user.publicProfile?.name) {
    void StateObserver.invoke.updatePublicProfile({ name: 'Human' });
  }

  // Update private profile name too, just in case
  if (!StateObserver.getState().user.profile?.name) {
    void StateObserver.invoke.updatePrivateProfile({ name: 'Human' });
  }

  // If there is an active visit session, clear it.
  if (StateObserver.getState().user.visit.visitSession) {
    void withLoading(() => StateObserver.invoke.asyncEndVisit(true));
  }
}
